import { COLOR_SWATCHES } from "../preferences/preferences.ts";

export function ColorSwatches({
  value,
  onChange,
  ariaLabel,
}: {
  value: string;
  onChange: (color: string) => void;
  ariaLabel: string;
}) {
  return (
    <fieldset className="m-0 flex min-w-0 flex-wrap items-center gap-1.5 border-0 p-0">
      <legend className="sr-only">{ariaLabel}</legend>
      {COLOR_SWATCHES.map((color) => {
        const selected = value.toUpperCase() === color.toUpperCase();
        return (
          <button
            key={color}
            type="button"
            aria-pressed={selected}
            aria-label={color}
            onClick={() => onChange(color)}
            className={[
              "size-4 rounded-full",
              selected
                ? "ring-2 ring-offset-2 ring-[var(--color-brand-500)] ring-offset-[var(--color-surface)]"
                : "ring-1 ring-[rgb(18_18_18/0.22)]",
            ].join(" ")}
            style={{ backgroundColor: color }}
          />
        );
      })}
    </fieldset>
  );
}
